import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
var BsDatepickerViewComponent = (function () {
    function BsDatepickerViewComponent() {
        this.onNavigate = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onHover = new EventEmitter();
    }
    BsDatepickerViewComponent.prototype.navigateTo = function (event) {
        this.onNavigate.emit(event);
    };
    BsDatepickerViewComponent.prototype.hoverHandler = function (event) {
        this.onHover.emit(event);
    };
    BsDatepickerViewComponent.prototype.selectHandler = function (event) {
        this.onSelect.emit(event);
    };
    BsDatepickerViewComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bs-datepicker-view',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n    <div class=\"bs-datepicker bs-timepicker label-success\">\n      <div class=\"bs-datepicker-head label-success\">\n        <bs-datepicker-navigation-view\n          *ngFor=\"let month of months\"\n          [month]=\"month\"\n          (onNavigate)=\"navigateTo($event)\"></bs-datepicker-navigation-view>\n      </div>\n      <div class=\"bs-datepicker-body\" *ngFor=\"let month of months\">\n        <bs-datepicker-month-view\n          [month]=\"month\"\n          [options]=\"options\"\n          (onHover)=\"hoverHandler($event)\"\n          (onSelect)=\"selectHandler($event)\"\n        ></bs-datepicker-month-view>\n      </div>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    BsDatepickerViewComponent.ctorParameters = function () { return []; };
    BsDatepickerViewComponent.propDecorators = {
        'months': [{ type: Input },],
        'options': [{ type: Input },],
        'onNavigate': [{ type: Output },],
        'onSelect': [{ type: Output },],
        'onHover': [{ type: Output },],
    };
    return BsDatepickerViewComponent;
}());
export { BsDatepickerViewComponent };
//# sourceMappingURL=bs-datepicker-view.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/themes/bs/bs-datepicker-view.component.js
// module id = 874
// module chunks = 103